import React from 'react';
import { Table, Tr, Td, Thead, Th } from 'reactable';

class RegionalOrganizationTable extends React.Component {

  renderThead() {
    const columns = ['Regional Organization', 'Additional Details'];

    return columns.map((column, index) => {
      return (
        <Th key={ index } column={ column }>
          { column }
        </Th>
      );
    });
  }

  renderTds(organization) {
    console.log('renderTd', organization)
    let content = [
        <Td key="Regional Organization" column="Regional Organization">
           {organization.name}
        </Td>,
        <Td key='Additional Details' column='Additional Details'>
          <a target="_blank" href={ organization.description }>
            {
              organization.organizationType === 'STATEMENT'? "Statement": "Report"
            }
          </a>
        </Td>
    ];
    return content.map(value => (value));
  }

  renderTrs() {
    const data = this.props.data;
    return data.map((item) => {
        return (<Tr>{ this.renderTds(item) }</Tr>)
      }
    );
  }

  renderNoData() {
    const type = this.props.type;

    return (
      <div className="no-needs-message">
        No { type } incidents reported
      </div>
    );
  }

  render() {
    const data = this.props.data;
    if (!data || data.length === 0) return this.renderNoData();

    return (
      <div className="oecd-table__container">
        <Table
          className="table oecd-table"
        >
          <Thead>
            { this.renderThead() }
          </Thead>
          { this.renderTrs() }
        </Table>
      </div>
    );
  }
}

export default RegionalOrganizationTable;



// WEBPACK FOOTER //
// ./src/components/RegionalOrganization/RegionalOrganizationTable.js